import { LocationId } from '@/components/modules/banner/BannerSlot';
import { classnames } from '@/helpers';
import '@/styles/modules/banner.scss';
import { BannerLinkWrapper } from '../helpers';
import { BannerConfig } from '../types';

type BannerType4Props = Pick<
  BannerConfig,
  | 'background_image_sm'
  | 'background_image_md'
  | 'background_image_lg'
  | 'background_alt_text'
  | 'cta'
  | 'background_image_height_reference_sm'
  | 'background_image_width_reference_sm'
  | 'background_image_height_reference_md'
  | 'background_image_width_reference_md'
  | 'background_image_height_reference_lg'
  | 'background_image_width_reference_lg'
> & {
  locationId?: LocationId; // only used for analytics
};

const BannerType4 = ({
  cta,
  background_image_lg,
  background_image_md,
  background_image_sm,
  background_alt_text,
  background_image_height_reference_sm,
  background_image_width_reference_sm,
  background_image_height_reference_md,
  background_image_width_reference_md,
  background_image_height_reference_lg,
  background_image_width_reference_lg,
  locationId,
}: BannerType4Props) => {
  const style: { [key: string]: string } = {
    '--ar-sm':
      background_image_width_reference_sm && background_image_height_reference_sm
        ? `${background_image_width_reference_sm} / ${background_image_height_reference_sm}`
        : '16 / 9',
    '--ar-md':
      background_image_width_reference_md && background_image_height_reference_md
        ? `${background_image_width_reference_md} / ${background_image_height_reference_md}`
        : '16 / 9',
    '--ar-lg':
      background_image_width_reference_lg && background_image_height_reference_lg
        ? `${background_image_width_reference_lg} / ${background_image_height_reference_lg}`
        : '16 / 9',
  };

  return (
    <BannerLinkWrapper cta={cta} type="type_4" locationId={locationId}>
      <div
        className={classnames(`
          aspect-[var(--ar-sm)]
          sm:aspect-[var(--ar-sm)]
          md:aspect-[var(--ar-md)]
          lg:aspect-[var(--ar-lg)]
      `)}
        style={style}>
        <picture>
          {/* based on breakpoints /src/breakpoints.ts */}
          <source media="(max-width: 576px)" srcSet={background_image_sm} />
          <source media="(max-width: 991px)" srcSet={background_image_md} />
          <source media="(min-width: 992px)" srcSet={background_image_lg} />
          <img className="h-full w-full object-cover" src={background_image_sm} alt={background_alt_text ?? ''} />
        </picture>
      </div>
    </BannerLinkWrapper>
  );
};

export default BannerType4;
